/**
 * @param preferenceCenter {HTMLElement}
 * @return {HTMLElement}
 */
module.exports = function getPreferenceCenterPhoneNumberFormatMessage(preferenceCenter) {
    const phoneNumberFormatMessage = preferenceCenter.querySelector('[data-component="phoneNumberFormatMessage"]');

    if (phoneNumberFormatMessage instanceof HTMLElement) {
        return phoneNumberFormatMessage;
    }

    throw new Error("getPreferenceCenterPhoneNumberFormatMessage: phoneNumberFormatMessage does not exist in preference center!");
}
